export const LABEL_MM = {

}
